const MANAGE_REPO_OWNERSHIP_PATH_SEGMENT = 'manage-repo-ownership';
const MANAGE_REPO_OWNERSHIP_PATH_SUFFIX = `/${MANAGE_REPO_OWNERSHIP_PATH_SEGMENT}`;

const MANAGE_JIRA_TEAM_OWNERSHIP_PATH_SEGMENT = 'manage-jira-team-ownership';
const MANAGE_JIRA_TEAM_OWNERSHIP_PATH_SUFFIX = `/${MANAGE_JIRA_TEAM_OWNERSHIP_PATH_SEGMENT}`;

const MANAGE_SUBSCRIPTION_OWNERSHIP_PATH_SEGMENT =
  'manage-subscription-ownership';
const MANAGE_SUBSCRIPTION_OWNERSHIP_PATH_SUFFIX = `/${MANAGE_SUBSCRIPTION_OWNERSHIP_PATH_SEGMENT}`;

const MANAGE_PAGERDUTY_TEAM_OWNERSHIP_PATH_SEGMENT =
  'manage-pagerduty-team-ownership';
const MANAGE_PAGERDUTY_TEAM_OWNERSHIP_PATH_SUFFIX = `/${MANAGE_PAGERDUTY_TEAM_OWNERSHIP_PATH_SEGMENT}`;

export const isManageRepoOwnershipPath = (pathname: string): boolean =>
  pathname.endsWith(MANAGE_REPO_OWNERSHIP_PATH_SUFFIX);

export const isManageJiraTeamOwnershipPath = (pathname: string): boolean =>
  pathname.endsWith(MANAGE_JIRA_TEAM_OWNERSHIP_PATH_SUFFIX);

export const isManageSubscriptionOwnershipPath = (pathname: string): boolean =>
  pathname.endsWith(MANAGE_SUBSCRIPTION_OWNERSHIP_PATH_SUFFIX);

export const isManagePagerDutyTeamOwnershipPath = (pathname: string): boolean =>
  pathname.endsWith(MANAGE_PAGERDUTY_TEAM_OWNERSHIP_PATH_SUFFIX);

export const getEntityCatalogRootPath = (pathname: string): string => {
  const pathWithoutSuffix = pathname.replace(
    /\/(manage-repo-ownership|manage-jira-team-ownership|manage-subscription-ownership|manage-pagerduty-team-ownership)\/?$/,
    '',
  );
  const parts = pathWithoutSuffix.split('/').filter(Boolean);

  if (parts[0] === 'catalog' && parts.length >= 4) {
    return `/${parts.slice(0, 4).join('/')}`;
  }

  return pathWithoutSuffix;
};

export const getManageRepoOwnershipPath = (pathname: string): string =>
  `${getEntityCatalogRootPath(pathname)}${MANAGE_REPO_OWNERSHIP_PATH_SUFFIX}`;

export const getManageJiraTeamOwnershipPath = (pathname: string): string =>
  `${getEntityCatalogRootPath(
    pathname,
  )}${MANAGE_JIRA_TEAM_OWNERSHIP_PATH_SUFFIX}`;

export const getManageSubscriptionOwnershipPath = (pathname: string): string =>
  `${getEntityCatalogRootPath(
    pathname,
  )}${MANAGE_SUBSCRIPTION_OWNERSHIP_PATH_SUFFIX}`;

export const getManagePagerDutyTeamOwnershipPath = (pathname: string): string =>
  `${getEntityCatalogRootPath(
    pathname,
  )}${MANAGE_PAGERDUTY_TEAM_OWNERSHIP_PATH_SUFFIX}`;
